// extracted by mini-css-extract-plugin
module.exports = {"video":"Video_video__2TVFu","vidWrapper":"Video_vidWrapper__1ojmz","inner":"Video_inner__16Ku8","chapters":"Video_chapters__q1My8","active":"Video_active__2fijH"};